/* eslint-disable */
// material-dashboard-react-main\src\services\authorizedDeviceService.js

import axios from "services/axiosConfig";

const DEVICE_STATUS_URL = "/api/auth/device-status";
const AUTHORIZED_DEVICES_URL = "/api/authorized-devices";

class AuthorizedDeviceService {
  static async getDeviceStatus() {
    const { data } = await axios.get(DEVICE_STATUS_URL, {
      params: { _: Date.now() },
    });
    return data;
  }

  static async requestDeviceAuthorization(label) {
    const body = {};
    if (label != null && String(label).trim()) body.label = String(label).trim();
    const { data } = await axios.post(`${AUTHORIZED_DEVICES_URL}/request`, body);
    return data;
  }

  static async getAuthorizedDevices() {
    const { data } = await axios.get(AUTHORIZED_DEVICES_URL, {
      params: { _: Date.now() },
    });
    return Array.isArray(data) ? data : [];
  }

  static async approveDevice(id) {
    const { data } = await axios.post(`${AUTHORIZED_DEVICES_URL}/${id}/approve`);
    return data;
  }

  static async revokeDevice(id) {
    const { data } = await axios.patch(`${AUTHORIZED_DEVICES_URL}/${id}/revoke`);
    return data;
  }
}

export default AuthorizedDeviceService;
